import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["absoluteFill", "alignHorizontal", "alignVertical", "backgroundColor", "backgroundColorArgs", "borderBottomLeftRadius", "borderBottomRightRadius", "borderColor", "borderColorArgs", "borderRadius", "borderTopLeftRadius", "borderTopRightRadius", "direction", "gap", "gapHorizontal", "gapVertical", "grow", "margin", "marginHorizontal", "marginVertical", "marginBottom", "marginTop", "marginLeft", "marginRight", "padding", "paddingHorizontal", "paddingVertical", "paddingBottom", "paddingTop", "paddingLeft", "paddingRight", "pointerEvents", "position", "left", "right", "top", "bottom", "shadow", "shrink", "wrap", "zIndex"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getColor, getRadius, getShadow, getSpace } from '../tokenUtils';
import { getAlignItems, getDirection, getJustifyContent } from './styleValueUtils';
var removeUnusedProperties = styleObject => Object.keys(styleObject).forEach(key => styleObject[key] === undefined && delete styleObject[key]);
export var getStyles = (designContext, _ref) => {
  var {
      absoluteFill,
      alignHorizontal,
      alignVertical,
      backgroundColor,
      backgroundColorArgs,
      borderBottomLeftRadius,
      borderBottomRightRadius,
      borderColor,
      borderColorArgs,
      borderRadius,
      borderTopLeftRadius,
      borderTopRightRadius,
      direction,
      gap,
      gapHorizontal = gap,
      gapVertical = gap,
      grow,
      margin,
      marginHorizontal = margin,
      marginVertical = margin,
      marginBottom = marginVertical,
      marginTop = marginVertical,
      marginLeft = marginHorizontal,
      marginRight = marginHorizontal,
      padding,
      paddingHorizontal = padding,
      paddingVertical = padding,
      paddingBottom = paddingVertical,
      paddingTop = paddingVertical,
      paddingLeft = paddingHorizontal,
      paddingRight = paddingHorizontal,
      pointerEvents,
      position = absoluteFill ? 'absolute' : undefined,
      left = absoluteFill ? 0 : undefined,
      right = absoluteFill ? 0 : undefined,
      top = absoluteFill ? 0 : undefined,
      bottom = absoluteFill ? 0 : undefined,
      shadow,
      shrink,
      wrap,
      zIndex
    } = _ref,
    restStyles = _objectWithoutProperties(_ref, _excluded);
  var styles = _objectSpread(_objectSpread({
    alignItems: getAlignItems({
      alignHorizontal,
      alignVertical,
      direction
    }),
    backgroundColor: getColor(designContext, backgroundColor, backgroundColorArgs),
    borderColor: getColor(designContext, borderColor, borderColorArgs),
    borderRadius: getRadius(designContext, borderRadius),
    borderBottomLeftRadius: getRadius(designContext, borderBottomLeftRadius),
    borderBottomRightRadius: getRadius(designContext, borderBottomRightRadius),
    borderTopLeftRadius: getRadius(designContext, borderTopLeftRadius),
    borderTopRightRadius: getRadius(designContext, borderTopRightRadius),
    bottom: getSpace(designContext, bottom),
    flexDirection: direction ? getDirection(direction) : undefined,
    flexGrow: grow === true ? 1 : grow === false ? 0 : grow,
    flexShrink: shrink === true ? 1 : shrink === false ? 0 : shrink,
    flexWrap: wrap ? 'wrap' : undefined,
    justifyContent: getJustifyContent({
      alignHorizontal,
      alignVertical,
      direction
    }),
    left: getSpace(designContext, left),
    marginBottom: getSpace(designContext, marginBottom),
    marginLeft: getSpace(designContext, marginLeft),
    marginRight: getSpace(designContext, marginRight),
    marginTop: getSpace(designContext, marginTop),
    paddingBottom: getSpace(designContext, paddingBottom),
    paddingLeft: getSpace(designContext, paddingLeft),
    paddingRight: getSpace(designContext, paddingRight),
    paddingTop: getSpace(designContext, paddingTop),
    pointerEvents: pointerEvents,
    right: getSpace(designContext, right),
    top: getSpace(designContext, top),
    columnGap: getSpace(designContext, gapHorizontal),
    rowGap: getSpace(designContext, gapVertical),
    position,
    zIndex,
    // There is a bug on Android that causes z-index to not always be taken into respect, adding an elevation fixes this issue
    elevation: typeof zIndex === 'number' && zIndex > 0 ? Number("0.0000".concat(zIndex)) : undefined
  }, getShadow(designContext, shadow)), restStyles);
  removeUnusedProperties(styles);
  return styles;
};
//# sourceMappingURL=styleUtils.js.map